import { JureJury } from './jure-jury.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { EchantillonJury } from './echantillon-jury.model';
import { DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Jury {
    static jsonMap = {
        id: { key: 'id', optional: true },
        ordre: { key: 'ordre' },
        jures: { key: 'jures', converter: new (ArrayClassConverterFactory.build(JureJury))() },
        cdcs: { key: 'idCahiers', converter: new (DataIdArrayConverterFactory.build(Cahier, 'cahiers'))() },
        echantillons: { key: 'echantillons', converter: new (ArrayClassConverterFactory.build(EchantillonJury))() }
    };

    id: number;
    ordre: number;
    jures: JureJury[];
    cdcs: Cahier[];
    echantillons: EchantillonJury[];
}
